import $ from 'jquery';
import BackgroundImage from './BackgroundImage';

const defaults = {
  breakpoint: 1200,
  location: '.background-video',
  destination: '.video-placeholder',
};

function Video(element, options, context) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.$body = this.getBody(context);
  this.videoElement = null;
  this.$bgVideo = this.getVideo();
  this.$destination = this.getDestination();
  this.init();
  this.ready();
}

Video.prototype = {
  init() {
    // if the background element or image isn't found, quit.
    if (!this.$bgVideo.length || !this.$destination) return;
    // show if applicable
    const showVideo = this.$bgVideo.children().length > 0 && !this.$element.find('.hero.banner .node-teaser').hasClass('hide-video');
    if (showVideo && $(window).width() >= this.settings.breakpoint && !this.isMobileDevice()) {
      this.videoElement = this.addVideo();
      this.$body.addClass('has-video');
    } else {
      // Let's use a background image for improved display.
      this.element.backgroundImage = new BackgroundImage(this.element);
    }

    // Ready the block
    this.ready();
  },
  isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  },
  getBody(context) {
    return $(document.body, context);
  },
  getVideo() {
    return this.$element.find(this.settings.location);
  },
  getDestination() {
    return this.$element.find(this.settings.destination);
  },
  addVideo() {
    const $source = this.$bgVideo.find('.video');
    const sources = $source.data('src').replace(/\s/g, '').split(',');
    const poster = this.$destination.attr('src');

    const $video = $(`<video autoplay loop muted poster="${poster}"></video>`);
    $.each(sources, (i, src) => {
      let type = src.substring(src.lastIndexOf('.') + 1);
      // Help out with setting the proper type for all Ogg Theora files.
      type = type.replace(/ogm|ogv/g, 'ogg');
      $video.append(`<source src="${src}" type="video/${type}">`);
    });

    this.$destination.replaceWith($video);
    $video[0].play();

    // Delete temp markup
    this.$bgVideo.remove();

    // Return the video element so it may be used by other components
    return $video[0];
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Video;
